/**
 * Route guard. Convenience only.
 *
 * This decides what renders, not what a person can reach. Any data behind it
 * is protected by RLS in Postgres, so a bug here shows the wrong screen rather
 * than the wrong records.
 */

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "./SessionProvider";

export function RequireAuth() {
  const { session } = useSession();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
